module.exports = __webpack_public_path__ + "media/images/emblems/Hohentannen-Blazono-e043c4366756376d15bd70181cad6545.png";